import { ACTIONS, CallBackProps, EVENTS, STATUS } from "react-joyride"
import { ignoreTutorialRequest } from "../../../pages/welcome/requests"
import { toast } from "react-toastify"
import { useAuth } from "../../../modules/auth"
import { useNavigate } from "react-router-dom"
import useTutorialProfile from "./useTutorialProfile"
import { TUTORIAL_PROFILE_STEPS } from "../steps/profile"
import useTutorialActivites from "./useTutorialActivites"

const useTutorialGlobal = () => {
     const { currentUser, setCurrentUser, userType } = useAuth()
     const { setInteractiveTutorial } = useAuth()
     const navigate = useNavigate()
     const { handleStart: handleStart__PROFILE, handleNext: handleNext__PROFILE, handlePrevious: handlePrevious__PROFILE } = useTutorialProfile()
     const { handleStart: handleStart__ACTIVITES, handleNext: handleNext__ACTIVITES, handlePrevious: handlePrevious__ACTIVITES } = useTutorialActivites()

     const handleJoyrideCallback = (data: CallBackProps) => {
          const { action, index, type, status } = data

          if (status === STATUS.FINISHED) {
               handleOnFinishTutorial()
               return
          }
          if (status === STATUS.SKIPPED && !currentUser?.user?.isTutorialSeen) {
               handleOnSkipTutorial()
               return
          }
          if (type === EVENTS.TARGET_NOT_FOUND) {
               // Wait 300 ms
               setTimeout(() => {
                    setInteractiveTutorial(prev => ({ ...prev, stepIndex: index }))
               }, 1000)
          }

          // Global tour always start with profile tour
          if (type === EVENTS.TOUR_START) {
               handleStart__PROFILE()
          }

          if (type === EVENTS.STEP_AFTER) {
               // --------------------------
               // FORWARD logic (Next button)
               // --------------------------
               if (action === ACTIONS.NEXT) {
                    if (index < TUTORIAL_PROFILE_STEPS.length - 1) {
                         handleNext__PROFILE(index)
                    }
                    if (index >= TUTORIAL_PROFILE_STEPS.length - 1) {
                         if (index === TUTORIAL_PROFILE_STEPS.length - 1) {
                              setInteractiveTutorial(prev => ({ ...prev, stepIndex: index + 1 }))
                              handleStart__ACTIVITES()
                         } else {
                              handleNext__ACTIVITES(index, TUTORIAL_PROFILE_STEPS.length)
                         }
                    }
               }

               // --------------------------
               // BACKWARD logic (Prev button)
               // --------------------------
               if (action === ACTIONS.PREV) {
                    if (index <= TUTORIAL_PROFILE_STEPS.length - 1) handlePrevious__PROFILE(index)
                    if (index === TUTORIAL_PROFILE_STEPS.length) {
                         navigate("/mon-compte/settings")
                         setInteractiveTutorial(prev => ({ ...prev, stepIndex: index - 1 }))
                    }
                    if (index > TUTORIAL_PROFILE_STEPS.length) {
                         handlePrevious__ACTIVITES(index, TUTORIAL_PROFILE_STEPS.length)
                    }
               }
          }
     }

     // When user clicks on the finish button
     const handleOnFinishTutorial = () => {
          setInteractiveTutorial({
               isEnable: false,
               stepIndex: null,
               target: null,
          })
     }

     // When user clicks on "skip"
     const handleOnSkipTutorial = () => {
          setInteractiveTutorial({
               isEnable: false,
               stepIndex: null,
               target: null,
          })

          ignoreTutorialRequest()
               .then(() => {
                    setCurrentUser(prev => ({
                         ...prev,
                         user: {
                              ...prev?.user,
                              isTutorialSeen: true,
                         },
                    }))
                    toast.info("Vous pourrez également accéder au tutoriel plus tard via le menu en haut de l’écran.", { autoClose: false })
                    if (userType === "CONSULTANT_SALARIE") {
                         navigate("/activites")
                    } else {
                         navigate("/")
                    }
               })
               .catch(e => {
                    toast.error(e.response.data?.detail, { autoClose: false })
               })
     }

     return { handleJoyrideCallback }
}

export default useTutorialGlobal
